@if (isLoading()) {
  <div class="grid grid-nogutter" id="client-reviewer-profile-loading">
    <div class="col-12 pb-3"><p-skeleton height="3rem"></p-skeleton></div>
    <div class="col-12 pb-3"><p-skeleton height="6rem"></p-skeleton></div>
    <div class="col-12"><p-skeleton height="10rem"></p-skeleton></div>
  </div>
} @else if (notFound() || !profile()) {
  <p class="m-0 body1" id="client-reviewer-profile-not-found">This reviewer has not worked on your group's projects.</p>
} @else {
  @if (profile(); as reviewer) {
  <div class="grid grid-nogutter profile-modal client-reviewer-profile">
    <div class="col-12 pb-3 border-bottom-1 border-gray-200 flex justify-content-between align-items-center flex-column xl:flex-row">
      <div class="avatar flex gap-3">
        <p-avatar
          [id]="isPwcEnabled() ? 'pwc-profile-logo' : ''"
          [image]="isPwcEnabled() ? 'assets/images/pwc-logo-profile.png' : 'assets/images/white-logo.png'"
          size="large"
          shape="circle"
        ></p-avatar>
        <div class="details">
          <h6 class="m-0 text-deep-purple-900 mb-1" id="client-reviewer-profile-name">{{ displayName() }}</h6>
          @if (reviewer.preferredFirstName) {
            <p class="m-0 body1">Preferred first name: {{ reviewer.preferredFirstName }}</p>
          }
          @if (reviewer.isCurrentlyWorking) {
            <p-tag severity="success" [value]="'Currently working' | sentenceCase"></p-tag>
          }
        </div>
      </div>
      <div class="rating flex align-items-center gap-3">
        <p-rating [ngModel]="reviewer.starRating" [readonly]="true" [cancel]="false" class="cursor-default" />
        @if (isPwcEnabled()) {
          <span class="text-base">Ranking: <strong>{{ reviewer.ranking || '-' }}</strong></span>
        }
      </div>
    </div>

    <div class="col-12 pt-3">
      <div class="grid grid-nogutter">
        <div class="col-12 lg:col-4 xl:col-4 pb-3 pr-0 lg:pr-2">
          <div class="wrap-worked flex border-round-lg justify-content-center gap-2 py-3 align-items-center">
            <span class="h5">{{ reviewer.projectsTogether }}</span>
            <p class="m-0 body2">{{ 'Projects Worked Together' | sentenceCase }}</p>
          </div>
        </div>
        <div class="col-12 lg:col-8 xl:col-8 pb-3">
          <span class="text-xl font-medium m-0 block pb-2">Projects</span>
          <div class="flex flex-wrap gap-2" id="client-reviewer-profile-projects">
            @for (name of projectNames(); track name) {
              <p-chip [label]="name"></p-chip>
            } @empty {
              <span class="body2">No projects to show.</span>
            }
          </div>
        </div>

        <div class="col-12 pb-2">
          <span class="text-xl font-medium m-0">{{ 'Position history' | sentenceCase }}</span>
        </div>
        <div class="col-12 data-table">
          <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="reviewer.positions || []" [tableStyle]="{ 'min-width': '40rem' }" [scrollable]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>Project</th>
                <th>Role</th>
                <th>Status</th>
                <th>Start</th>
                <th>Filled</th>
                <th>Finished</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-position>
              <tr>
                <td>{{ position.project?.codeName || '-' }}</td>
                <td>{{ position.roleType || '-' }}</td>
                <td>{{ (position.status | sentenceCase) || '-' }}</td>
                <td>{{ position.startAt ? (position.startAt | date: 'MM/dd/yyyy') : '-' }}</td>
                <td>{{ position.filledAt ? (position.filledAt | date: 'MM/dd/yyyy') : '-' }}</td>
                <td>{{ position.finishedAt ? (position.finishedAt | date: 'MM/dd/yyyy') : '-' }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr><td colspan="6">No positions on your group's projects.</td></tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
  }
}
